import { render, staticRenderFns } from "./exhibition-template-franchisee.vue?vue&type=template&id=14b8c3fe&scoped=true&"
import script from "./exhibition-template-franchisee.vue?vue&type=script&lang=js&"
export * from "./exhibition-template-franchisee.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-template-franchisee.vue?vue&type=style&index=0&id=14b8c3fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b8c3fe",
  null
  
)

export default component.exports